import * as PIXI from 'pixi.js';
import GSOParasite from '../../Game/Base/GSOParasite';
import Global from '../../Game/Global';
import CanvasImageButton from '../CanvasImageButton';
import AssetManager from '../../Game/Base/AssetManager';
import ClickVoid from './ClickVoid';

export default class LevelOverlay extends GSOParasite {
    constructor(realParent, stepParent) {
        super(realParent, stepParent);

        this.pixiContainer = null;

        this.scaleUpButton = new CanvasImageButton(this, AssetManager.get('img.btn_level_size_up'));
        this.scaleUpButton.zIndex = 1;
        this.scaleUpButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.mouseStart = mousePosition;
        };
        this.scaleUpButton.onMouseMove = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const level = this._gsoParent.getAttachedStepParent();
            let div = Math.round((this.mouseStart.y - mousePosition.y) / Global.NATIVE_BLOCK_SIZE);
            if (div !== 0 && level.size.y + div < Global.NATIVE_LEVEL_HEIGHT) {
                div = -(level.size.y - 1);
            }
            if (div !== 0 && level.size.y + div >= Global.NATIVE_LEVEL_HEIGHT) {
                level.size.y += div;
                level.position.y -= div;
                this.mouseStart.y -= div * Global.NATIVE_BLOCK_SIZE;
                if (div > 0) level.background.addRows(div);
                else level.background.removeRows(-div);
            }
        };

        this.scaleDownButton = new CanvasImageButton(this, AssetManager.get('img.btn_level_size_down'));
        this.scaleDownButton.zIndex = 1;
        this.scaleDownButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.mouseStart = mousePosition;
        };
        this.scaleDownButton.onMouseMove = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const level = this._gsoParent.getAttachedStepParent();
            let div = Math.round((mousePosition.y - this.mouseStart.y) / Global.NATIVE_BLOCK_SIZE);
            if (div !== 0 && level.size.y + div < Global.NATIVE_LEVEL_HEIGHT) {
                div = -(level.size.y - 1);
            }
            if (div !== 0 && level.size.y + div >= Global.NATIVE_LEVEL_HEIGHT) {
                level.size.y += div;
                this.mouseStart.y += div * Global.NATIVE_BLOCK_SIZE;
                if (div > 0) level.background.addRows(-div);
                else level.background.removeRows(div);
            }
        };

        this.scaleLeftButton = new CanvasImageButton(this, AssetManager.get('img.btn_level_size_left'));
        this.scaleLeftButton.zIndex = 1;
        this.scaleLeftButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.mouseStart = mousePosition;
        };
        this.scaleLeftButton.onMouseMove = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const level = this._gsoParent.getAttachedStepParent();
            let div = Math.round((this.mouseStart.x - mousePosition.x) / Global.NATIVE_BLOCK_SIZE);
            if (div !== 0 && level.size.x + div < Global.NATIVE_LEVEL_WIDTH) {
                div = -(level.size.x - 1);
            }
            if (div !== 0 && level.size.x + div >= Global.NATIVE_LEVEL_WIDTH) {
                level.size.x += div;
                level.position.x -= div;
                this.mouseStart.x -= div * Global.NATIVE_BLOCK_SIZE;
                if (div > 0) level.background.addColumns(-div);
                else level.background.removeColumns(-div);
            }
        };

        this.scaleRightButton = new CanvasImageButton(this, AssetManager.get('img.btn_level_size_right'));
        this.scaleRightButton.zIndex = 1;
        this.scaleRightButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.mouseStart = mousePosition;
        };
        this.scaleRightButton.onMouseMove = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const level = this._gsoParent.getAttachedStepParent();
            let div = Math.round((mousePosition.x - this.mouseStart.x) / Global.NATIVE_BLOCK_SIZE);
            if (div !== 0 && level.size.x + div < Global.NATIVE_LEVEL_WIDTH) {
                div = -(level.size.x - 1);
            }
            if (div !== 0 && level.size.x + div >= Global.NATIVE_LEVEL_WIDTH) {
                level.size.x += div;
                this.mouseStart.x += div * Global.NATIVE_BLOCK_SIZE;
                if (div > 0) level.background.addColumns(div);
                else level.background.removeColumns(div);
            }
        };

        this.clickVoidButton = new ClickVoid(this);
        this.clickVoidButton.zIndex = -9999;
        this.clickVoidButton.onMouseDown = function(mousePosition) {
            realParent.onMouseDown(mousePosition);
        };
        this.clickVoidButton.onMouseMove = function(mousePosition) {
            realParent.onMouseMove(mousePosition);
        };
        this.clickVoidButton.onMouseUp = function(mousePosition) {
            realParent.onMouseUp(mousePosition);
        };
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();
        this.getAttachedStepParent().pixiContainerOverlayLayer.addChild(this.pixiContainer);
    }

    onUpdateVisuals() {
        const level = this.getAttachedStepParent();
        this.scaleUpButton.position.x = (level.size.x * Global.NATIVE_BLOCK_SIZE) / 2 + level.position.x * Global.NATIVE_BLOCK_SIZE;
        this.scaleUpButton.position.y = -18 + level.position.y * Global.NATIVE_BLOCK_SIZE;

        this.scaleDownButton.position.x = (level.size.x * Global.NATIVE_BLOCK_SIZE) / 2 + level.position.x * Global.NATIVE_BLOCK_SIZE;
        this.scaleDownButton.position.y = level.size.y * Global.NATIVE_BLOCK_SIZE + 18 + level.position.y * Global.NATIVE_BLOCK_SIZE;

        this.scaleLeftButton.position.x = -18 + level.position.x * Global.NATIVE_BLOCK_SIZE;
        this.scaleLeftButton.position.y = (level.size.y * Global.NATIVE_BLOCK_SIZE) / 2 + level.position.y * Global.NATIVE_BLOCK_SIZE;

        this.scaleRightButton.position.x = level.size.x * Global.NATIVE_BLOCK_SIZE + 18 + level.position.x * Global.NATIVE_BLOCK_SIZE;
        this.scaleRightButton.position.y = (level.size.y * Global.NATIVE_BLOCK_SIZE) / 2 + level.position.y * Global.NATIVE_BLOCK_SIZE;
    }

    onDestroyVisuals() {
        this.pixiContainer.destroy();
    }
}
